$(document).on('show.bs.tooltip', '.cor-activity-message-tooltip', function (e) {
    let target = $(e.target);
    if (target[0].scrollWidth > (target.width()) + 1) {
        target.attr('data-original-title', target.text())
            .tooltip('update');
        return;
    }
    setTimeout(function () {
        target.tooltip('dispose');
    });
})
